import {he_scale, madnes_objects, quality, wi_scale} from "./madnes_variables";
import {main_phaser} from "./MadnesApp";
import {madnes_get_dimension_wi, madnes_key_exist} from "./madnes_object";
import {intFormat} from "../../helpers";

export function madnes_add_text(name, x, y, text, style, phaser = main_phaser)
{
    var style2 = JSON.parse(JSON.stringify(style));
    if(madnes_key_exist(name))
    {
        console.warn("Object " + name + " already exist.");
        return;
    }

    if(quality < 100)
    {
        var tmp = style.font.substr(0, style2.font.indexOf("px"));
        tmp = parseInt(tmp, 10);
        if(!isNaN(tmp))
        {
            tmp = Math.ceil(tmp / ( 100 / quality ) );
            style2.font = tmp + style2.font.substr(style2.font.indexOf("px"));
        }
    }

    madnes_objects[name] = phaser.add.text(x * wi_scale, y * he_scale, text, style2);
}

export function phaser_add_text({name, x, y, text, style, phaser}) {
    madnes_add_text(name, x, y, text, style, phaser);
}

/**
 * @param {string} name
 * @param {string|number|null} text
 * @param {boolean=} noformat
 */
export function madnes_set_text(name, text, noformat) {
    if(typeof noformat == "undefined")
    {
        noformat = false;
    }

    if(!noformat)
    {
        text = madnes_format_text(text);
    }

    madnes_objects[name].setText(text);
}

export function madnes_set_bitmaptext_float(name, num, decimals, roundIfInteger = false) {
    madnes_objects[name].setText(float_bitmap_text(num, decimals, roundIfInteger));
}

export function madnes_format_text(text) {
    var format = false;
    var tmp = null;

    text = text.toString();

    if(!isNaN(text * 1))
    {
        format = true;
    }
    else if(text.indexOf(": ") != -1)
    {
        tmp = (text + "").split(": ");
        if(tmp.length == 2 && !isNaN(tmp[1] * 1))
        {
            format = true;
            text = tmp[1];
        }
    }

    if(format)
    {
        var text2 = "";
        var pos = 0;
        for(var i = text.toString().length - 1; i >= 0; i--)
        {
            if(pos % 3 == 0 && pos != 0)
            {
                text2 = " " + text2;
            }
            pos++;
            text2 = text.toString().substr(i, 1) + text2;
        }
        if(tmp != null && tmp.length == 2)
        {
            text2 = tmp[0] + ": " + text2;
        }
        text = text2;
    }

    return text;
}

export function madnes_set_text_shadow(name, x, y, color, blur, shadowStroke, shadowFill) {
    madnes_objects[name].setShadow(x, y, color, blur, shadowStroke, shadowFill);
}

export function madnes_add_bitmap_text(name, key, x, y, text, s, phaser = main_phaser)
{
    if(madnes_key_exist(name))
    {
        console.log("Object " + name + " already exist.");
        return;
    }

    madnes_objects[name] = phaser.add.bitmapText(x * wi_scale, y * he_scale, key, text, s / ( 100 / quality ) );
}

export function phaser_add_bitmap_text(name, key, x, y, text, s, phaser = main_phaser)
{
    if(madnes_key_exist(name))
    {
        console.log("Object " + name + " already exist.");
        return;
    }

    madnes_objects[name] = phaser.add.bitmapText(x * wi_scale, y * he_scale, key, text, s / ( 100 / quality ) );
}

/**
 * @param {string} name
 * @param {string} key
 * @param {number} x
 * @param {number} y
 * @param {string} text
 * @param {number} s
 * @param {number} max_width
 * @param {boolean=} noformat
 */
export function madnes_add_bitmap_float(name, key, x, y, text, s, max_width, noformat) {
    madnes_add_bitmap_text(name, key, x, y, text, s);
    madnes_set_bitmap_float(name, text, max_width, noformat);
}

/**
 * @param {string} name
 * @param {string} key
 * @param {number} x
 * @param {number} y
 * @param {string} text
 * @param {number} s
 * @param {number} max_width
 * @param {boolean=} noformat
 */
export function phaser_add_bitmap_float({name, key, x, y, text, s, max_width, noformat, phaser = main_phaser}) {
    phaser_add_bitmap_text(name, key, x, y, text, s, phaser);
    madnes_set_bitmap_float(name, text, max_width, noformat);
}

/**
 * @param {number} max_width - if text width is greater than max_width, it's transformed to "lower" bitmap text
 * @param {boolean=} noformat
 */
export function madnes_set_bitmap_float(name, fl, max_width, noformat) {
    if(max_width)
    {
        madnes_set_text(name, fl, noformat);
    }

    if(max_width && madnes_get_dimension_wi(name) > max_width)
    {
        var text = fl.toString();

        if(!noformat)
        {
            text = madnes_format_text(text);
        }

        text = text.replace(/0/g, "a").replace(/1/g, "b").replace(/2/g, "c").replace(/3/g, "d")
            .replace(/4/g, "e").replace(/5/g, "f").replace(/6/g, "g").replace(/7/g, "h")
            .replace(/8/g, "i").replace(/9/g, "j").replace(/\./g, "k").replace(/,/g, "l")
            .replace(/S/g, "m").replace(/U/g, "n").replace(/G/g, "o").replace(/A/g, "p")
            .replace(/\//g, "q").replace(/\-/g, "r").replace(/X/g, "x");

        madnes_set_text(name, text, true);
    }
    else
    {
        madnes_set_text(name, fl, noformat);
    }
}

export function madnes_set_font_size(name, size)
{
    madnes_objects[name].fontSize = size;
}

export function madnes_get_text(name)
{
    return madnes_objects[name].text;
}

export function madnes_set_text_bounds(name, x1, y1, x2, y2) {
    madnes_objects[name].setTextBounds(x1, y1, x2, y2);
}

function madnes_round(num, decimals) {
    return ((num * (10 ** decimals)) | 0) / 10 ** decimals;
}

export function float_bitmap_text(num, decimals = 2, roundIfInteger = false) {

    if(roundIfInteger && num % 1 === 0) return num + "";

    let nump = ((num * (10 ** decimals)) | 0);
    let decstr = (nump + "").slice(-2);

    return intFormat(num | 0) + "." + madnes_convert_string_to_lowercase_bitmap(decstr);
}

export function madnes_convert_string_to_lowercase_bitmap(str) {

    let lowerStr = "";

    for(let i = 0, l = str.length; i < l; i++) {
        lowerStr += madnes_convert_char_lowercase_bitmap(str[i]);
    }

    return lowerStr;
}

export function madnes_convert_char_lowercase_bitmap(char) {
    switch(char) {
        case "0": return "a";
        case "1": return "b";
        case "2": return "c";
        case "3": return "d";
        case "4": return "e";
        case "5": return "f";
        case "6": return "g";
        case "7": return "h";
        case "8": return "i";
        case "9": return "j";
        default: return "";
    }
}